import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Label, Select } from 'semantic-ui-react';
import ReactTable from 'react-table';

import 'Styles/components/importPreviewTable.less';

import { caseInsensitiveFilter, SelectHeader } from './GridHelper';

class FilePreview extends Component {
  static propTypes = {
    options: PropTypes.array,
    fileData: PropTypes.array,
    style: PropTypes.object,
    updatePreviewData: PropTypes.func,
    resizable: PropTypes.bool,
    useSelectPortal: PropTypes.bool,
    hasHeaderInfo: PropTypes.bool,
    tableColProps: PropTypes.object,
  };

  static defaultProps = {
    options: [],
    fileData: [],
    style: {},
    updatePreviewData: () => {},
    resizable: false,
    useSelectPortal: false,
    hasHeaderInfo: false,
    tableColProps: {},
  };

  constructor(props) {
    super(props);

    this.state = {
      error: false,
      ...this.getTableDataAndCols(),
    };
  }

  componentDidUpdate(prevProps) {
    const { fileData } = this.props;
    const { fileData: prevFileData } = prevProps;

    if (prevFileData !== fileData) {
      this.setState(this.getTableDataAndCols());
    }
  }

  /**
   * Builds the table data and columns used by ReactTable.
   */
  getTableDataAndCols() {
    const { fileData } = this.props;
    let tableData = [];
    let fields = [];

    if (fileData.length) {
      fields = fileData[0];

      tableData = fileData.map(row =>
        row.reduce((acc, data, index) => {
          acc['col' + index] = data;
          return acc;
        }, {})
      );
    }

    return { tableData, fields };
  }

  addData = (event, { value }, i) => {
    let response = this.props.updatePreviewData(value, i);
    if (response) {
      this.setState({ error: false });
    } else {
      this.setState({ error: true });
    }
  };

  getValue = index => {
    const { header, options } = this.props;

    if (header.length > 0) {
      const match = header.find(x => x.ColumnNumber === index);

      if (match) {
        const optionMatch = options.find(x => {
          return x.text === match.FieldName;
        });
        if (optionMatch) return optionMatch.value;
      }
    }

    return -1;
  };

  renderSelectComponent = i => {
    const { useSelectPortal, options, hasHeaderInfo, headerInfo } = this.props;
    const { error } = this.state;

    let cog;

    let Header = null;

    if (hasHeaderInfo) {
      Header = (
        <div style={{ height: 25 }}>{headerInfo ? headerInfo[i] : null}</div>
      );
    }

    const SelectComponent = useSelectPortal ? (
      <SelectHeader
        value={this.getValue(i)}
        options={options}
        error={error}
        onChange={(event, data) => {
          this.addData(event, data, i);
        }}
      />
    ) : (
      <Select
        options={options}
        fluid
        onChange={(event, data) => {
          this.addData(event, data, i);
        }}
        error={error}
        onOpen={e => {
          cog = e.currentTarget.closest('.rt-th');
          if (cog) {
            cog.style.zIndex = 2;
            cog.style.overflow = 'inherit';
          }
        }}
        onClose={() => {
          if (cog) {
            cog.style.zIndex = null;
            cog.style.overflow = 'hidden';
          }
        }}
        value={this.getValue(i)}
        search={true}
      />
    );

    return (
      <React.Fragment>
        {Header}
        {SelectComponent}
      </React.Fragment>
    );
  };

  get columns() {
    const { tableColProps } = this.props;
    const { fields } = this.state;
    return fields.map((fieldData, i) => ({
      Header: this.renderSelectComponent(i),
      accessor: 'col' + i,
      ...tableColProps,
    }));
  }

  render() {
    const { style, resizable, hasHeaderInfo } = this.props;
    const { tableData } = this.state;

    return (
      <div className="form--file-preview" style={style}>
        {Array.isArray(tableData) && tableData.length > 0 && (
          <div>
            {hasHeaderInfo && (
              <Label
                style={{ position: 'absolute', top: 69, left: 0 }}
                as="a"
                color="orange"
                ribbon
              >
                Match file header to desired column
              </Label>
            )}

            <ReactTable
              data={tableData}
              resizable={resizable}
              showPagination={false}
              defaultPageSize={10}
              className="import-preview-table -striped -highlight lg-width"
              getTableProps={this.getColInfo}
              defaultFilterMethod={caseInsensitiveFilter}
              columns={this.columns}
            />
          </div>
        )}
      </div>
    );
  }
}

export default FilePreview;



// WEBPACK FOOTER //
// ./src/common/FilePreview.js